import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import ProductList from "./product/ProductList";
import TrackingHistory from "./TrackingHistory";
import ProgressBar from "../../ProgressBar";
import Map from "../../Map";
import RecommendProductList from "./product/RecomendProductList";
import DisplayReview from "../../DisplayReview";
import ProgressBarMobile from "../../ProgressBarMobile";
import TrackingPreview from "../theme_special/TrackingPreview";
import { Accordion } from "react-bootstrap";
import ButtonResyncDetail from "../../ButtonResyncDetail";

const TrackingResult = () => {
  const {
    general: settings,
    productRecommend,
    progressBar,
    reviewQuestions,
  } = useSelector((state) => state.settings);
  const orders = useSelector((state) => state.order);
  const checkSize = useRef();
  const [stt, setStt] = useState([]);
  const handleChangeStt = (index) => {
    const arrayClone = [...stt];
    const indexItem = arrayClone.indexOf(index);
    if (arrayClone.includes(index)) {
      arrayClone.splice(indexItem, 1);
    } else {
      arrayClone.push(index);
    }

    setStt(arrayClone);
  };

  return (
    <div className={`omg-layout omg-layout--${settings.layout}`}>
      {orders.map((order, index) => (
        <div className="pb-3" key={index}>
          <div
            className="omg-tracking-result-preview container"
            style={{ border: "1px solid #000" }}
          >
            <div
              className="d-flex justify-content-end"
              style={{ width: "100%" }}
            >
              <ButtonResyncDetail
                order_id={order?.order_id}
                trackingCompany={order?.tracking_company}
                trackingNumber={order?.tracking_number}
                orderIndex={index}
              />
            </div>
            <Accordion
              alwaysOpen={false}
              defaultActiveKey={orders.length > 1 ? -1 : 0}
            >
              <Accordion.Item eventKey={index}>
                <Accordion.Header>
                  <TrackingPreview order={order} index={index} stt={stt} />
                </Accordion.Header>
                <Accordion.Body>
                  <div className="container" style={{ padding: 0 }}>
                    <div className="card card-body">
                      <div className="row" ref={checkSize}>
                        <div
                          className="section-progress"
                          style={{ zIndex: "0" }}
                        >
                          {settings.show.includes("progress_bar") && (
                            <ProgressBar order={order} />
                          )}
                        </div>
                      </div>

                      <div className="row info-tracking ">
                        <div className="col-sm-12 col-md-6 section-tracking-logs ">
                          <TrackingHistory settings={settings} order={order} />
                        </div>
                        <div className="col-sm-12 col-md-6 section-order-detail">
                          {settings.show.includes("order_detail") && (
                            <ProductList order={order} />
                          )}
                        </div>
                      </div>
                      <div className="section-map">
                        {settings.show.includes("map") && <Map order={order} />}
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            {/* <div
              className={`preview-button`}
              data-bs-toggle="collapse"
              href={`#collapseExample-${index}`}
              role="button"
              aria-expanded={orders.length <= 1 ? "true" : "false"}
              aria-controls={`collapseExample-${index}`}
              onClick={() => {
                handleChangeStt(index);
              }}
            >
              <TrackingPreview order={order} index={index} stt={stt} />
            </div> */}
          </div>
        </div>
      ))}
      {reviewQuestions &&
        reviewQuestions?.reviewSettings?.isActive &&
        reviewQuestions?.reviewSettings?.show.length !== 0 && (
          <>
            <div className="omg-default-display-review">
              <div className="section-recommend-products">
                {productRecommend.isActive === true && (
                  <RecommendProductList order={orders[0]} />
                )}
              </div>
              {/* <DisplayReview
                mainColor={progressBar?.color}
                setting={reviewQuestions?.reviewSettings}
              /> */}
            </div>
          </>
        )}
    </div>
  );
};

export default TrackingResult;
